module.exports = require('./dist/anychart-bundle.min.js');



//////////////////
// WEBPACK FOOTER
// ./~/anychart/index.js
// module id = 140
// module chunks = 0